import Sentry from "@similarweb/sentry-logger";

import { autoCompleteService } from "app/services/autocomplete.service";
import type { IAutoCompleteResponse } from "app/@types/autocomplete";

interface AutocompleteWrapperParams {
    term: string;
}

/**
 * Wrapper function to replace the deleted getAutoCompleteSuggestions
 */
export const getAutoCompleteSuggestions = async (params: AutocompleteWrapperParams): Promise<any[]> => {
    try {
        const response: IAutoCompleteResponse = await autoCompleteService.getAutoCompleteSuggestions({
            query: params.term,
            searchTypeStr: "WEBSITE",
        });

        if (Array.isArray(response)) {
            return response.map((item: any) => ({
                name: item.name,
                image: item.image,
            }));
        }

        if ((response as any).Domains) {
            return (response as any).Domains.map((item: any) => ({
                name: item.name,
                image: item.image,
            }));
        }

        return [];
    } catch (error) {
        Sentry.error("Autocomplete error: ", error);
        return [];
    }
};
